import { request } from '@/utils/http'
import { type TenantUserVO } from '@/api/staff'

export interface BusinessManagerQueryRequest {
  // 分页参数
  /** 当前页码，默认为1 */
  pageNum?: number | null;
  /** 每页大小，默认为10 */
  pageSize?: number | null;

  // 查询参数
  /** 唯一标识 */
  id?: string | null
  /** 员工ID列表 */
  employeeIds?: string[] | null;
  /** 业务类型 */
  businessTypes?: number[] | null
  /** 岗位类型 */
  dedicatedTypes?: number[] | null
  /** 运价类型 */
  freightTypes?: number[] | null
  /** 起运港ID列表 */
  loadingPortIds?: string[] | null
  /** 目的港ID列表 */
  destinationPortIds?: string[] | null
  /** 卸货港ID列表 */
  dischargePortIds?: string[] | null
  /** 航线ID列表 */
  laneIds?: string[] | null
  /** 承运人ID列表 */
  carrierIds?: string[] | null
  /** 客户ID列表 */
  clientIds?: string[] | null
}

export interface BusinessManagerSaveRequest {
  /** 唯一标识 */
  id?: string | null;
  /** 员工ID */
  employeeId?: string | null;
  /** 业务类型 */
  businessTypes?: number[] | null
  /** 岗位类型 */
  dedicatedTypes?: number[] | null
  /** 运价类型 */
  freightTypes?: number[] | null
  /** 起运港ID列表 */
  loadingPortIds?: string[] | null
  /** 目的港ID列表 */
  destinationPortIds?: string[] | null
  /** 卸货港ID列表 */
  dischargePortIds?: string[] | null
  /** 航线ID列表 */
  laneIds?: string[] | null
  /** 承运人ID列表 */
  carrierIds?: string[] | null
  /** 客户ID列表 */
  clientIds?: string[] | null
}

export interface BusinessManagerVO {
  /** 唯一标识 */
  id?: string | null;
  /** 创建人 */
  createdBy?: string | null;
  /** 创建时间 */
  dateCreated?: string | null;
  /** 更新人 */
  modifiedBy?: string | null;
  /** 更新时间 */
  dateModified?: string | null;
  /** 员工ID */
  employeeId?: string | null;
  /** 业务类型 */
  businessTypes?: number[] | null;
  /** 岗位类型 */
  dedicatedTypes?: number[] | null;
  /** 运价类型 */
  freightTypes?: number[] | null;
  /** 起运港ID列表 */
  loadingPortIds?: string[] | null;
  /** 目的港ID列表 */
  destinationPortIds?: string[] | null;
  /** 卸货港ID列表 */
  dischargePortIds?: string[] | null;
  /** 航线ID列表 */
  laneIds?: string[] | null;
  /** 承运人ID列表 */
  carrierIds?: string[] | null;
  /** 客户ID列表 */
  clientIds?: string[] | null

  /** 序号，仅用于前端展现 */
  serialNo?: number | null
}

export interface PageResult<T> {
  /** 当前页码 */
  pageNum: number
  /** 每页大小 */
  pageSize: number
  /** 总条数 */
  total: number
  /** 列表 */
  list: T[]
}

// 获取航线负责人详情
export const getBusinessManager = (id: string) => {
  return request.post<BusinessManagerVO>('/enterprise/shipping-manager/get', { id })
}

// 保存或更新航线负责人
export const saveBusinessManager = (data: BusinessManagerSaveRequest) => {
  return request.post<string>('/enterprise/shipping-manager/save', data)
}

// 删除航线负责人
export const deleteBusinessManager = (id: string) => {
  return request.post<boolean>('/enterprise/shipping-manager/delete', { id })
}

// 批量删除航线负责人
export const batchDeleteBusinessManager = (ids: string[]) => {
  return request.post<boolean>('/enterprise/shipping-manager/delete', { ids })
}

// 分页查询航线负责人
export const pageBusinessManager = (params: BusinessManagerQueryRequest) => {
  return request.post<PageResult<BusinessManagerVO>>('/enterprise/shipping-manager/page', params)
}

export interface ShippingManagerMatchRequest {
  businessTypes?: number[]
  dedicatedTypes?: number[]
  freightTypes?: number[]
  loadingPortIds?: string[]
  destinationPortIds?: string[]
  dischargePortIds?: string[]
  laneIds?: string[]
  carrierIds?: string[]
  clientIds?: string[]
}

// 匹配业务负责人，返回匹配的员工 TenantUserVO 列表（已按 employeeId distinct）
export const matchShippingManagers = (params: ShippingManagerMatchRequest) => {
  return request.post<TenantUserVO[]>('/enterprise/shipping-manager/match', params)
}
